import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { SymbolEvent } from 'widgets/corpActions/data/SymbolEvent';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';
import { getSymbolEventTypeValue } from 'widgets/corpActions/api/SymbolEventsRequest';
import { isCorpActionHolidayType } from 'widgets/corpActions/data/HolidayType';

export default function all(
    corporateAction: SymbolEvent,
    withTitle = true
): GridDetailsPanelColumnDef<SymbolEventColumn>[] {
    const caTypeLabel = getSymbolEventTypeValue(corporateAction.type);

    if (isCorpActionHolidayType(corporateAction.type)) {
        return [
            {
                fullWidth: true,
                controls: [
                    {
                        type: 'title',
                        text: `${caTypeLabel} Details`,
                    },
                ],
            },
        ];
    }

    return [
        withTitle
            ? {
                  fullWidth: true,
                  controls: [
                      {
                          type: 'title',
                          text: `${corporateAction.symbol}: Additional Details for ${caTypeLabel}`,
                      },
                  ],
              }
            : {
                  controls: [],
              },

        {
            controls: [
                { type: 'field', field: 'bloombergSymbol' },
                { type: 'field', field: 'announcementDate' },
            ],
        },
        {
            controls: [
                { type: 'field', field: 'amdDate' },
                { type: 'field', field: 'effectiveDate' },
            ],
        },
    ];
}
